

























import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {EssenceAchat} from '@/models';

import CrudEssenceAchatList from '@/components/Crud/EssenceAchat/List.vue';
import CrudEssenceAchatListAchat from '@/components/Crud/EssenceAchat/ListEssenceAchat.vue';

import storeEssenceAchat, {EssenceAchatFilter} from '@/stores/modules/essenceAchat';

@Component({
	components: {
		CrudEssenceAchatList,
		CrudEssenceAchatListAchat,
	}
})
export default class EssenceAchatListView extends Vue {

	@Stored(() => storeEssenceAchat) private essenceAchats!: ResultType<EssenceAchat>;
	@Stored(() => storeEssenceAchat) private filters!: EssenceAchatFilter;

	private imgPath: string = "";

	private editEssenceAchat: EssenceAchat = null;
	private deletedEssenceAchat: EssenceAchat = null;
	private storeEssenceAchat = storeEssenceAchat;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editEssenceAchat = new EssenceAchat();
		this.refresh();
	}

	private refresh(): void {
		storeEssenceAchat.dispatch('getC', { filters: true });
	}
}
